import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { appointmentAnalysesActions } from 'features/appointmentAnalyses';

const useAppointmentAnalyses = () => {
  const dispatch = useDispatch();
  const getAppointmentAnalyses = useCallback(({ offset }) => dispatch(appointmentAnalysesActions.getAppointmentAnalyses({ offset })), [dispatch]);
  const getAppointmentAnalysis = useCallback(({ id, cable }) => dispatch(appointmentAnalysesActions.getAppointmentAnalysis({ id, cable })), [dispatch]);
  const clearLocalAppointmentAnalyses = useCallback(() => dispatch(appointmentAnalysesActions.clearLocalAppointmentAnalyses()), [dispatch]);
  const clearLocalActiveAppointmentAnalysis = useCallback(() => dispatch(appointmentAnalysesActions.clearLocalActiveAppointmentAnalysis()), [dispatch]);

  return {
    getAppointmentAnalyses,
    getAppointmentAnalysis,
    clearLocalAppointmentAnalyses,
    clearLocalActiveAppointmentAnalysis
  };
};

export default useAppointmentAnalyses;